import React, { useState, useEffect } from 'react';
import {
    Container,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Paper,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Box,
} from '@mui/material';
import { supabase } from '../lib/supabase';

function SourcePage() {
    const [sources, setSources] = useState([]);
    const [open, setOpen] = useState(false);
    const [name, setName] = useState('');
    const [editingId, setEditingId] = useState(null);

    useEffect(() => {
        fetchSources();
    }, []);

    const fetchSources = async () => {
        const { data, error } = await supabase.from('sources').select('*');
        if (error) {
            console.error('Error fetching sources:', error);
        } else {
            setSources(data || []);
        }
    };

    const handleOpen = (source = null) => {
        if (source) {
            setName(source.name);
            setEditingId(source.id);
        } else {
            setName('');
            setEditingId(null);
        }
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setName('');
        setEditingId(null);
    };

    const handleSave = async () => {
        if (editingId) {
            await supabase.from('sources').update({ name }).eq('id', editingId);
        } else {
            console.log('hereee');
            await supabase.from('sources').insert({ name });
        }
        handleClose();
        fetchSources();
    };

    const handleDelete = async (sourceId) => {
        if (window.confirm('Are you sure you want to delete this source? This action cannot be undone.')) {
            try {
                const { error } = await supabase
                    .from('sources')
                    .delete()
                    .eq('id', sourceId);

                if (error) {
                    console.error('Error deleting source:', error);
                    alert('Error deleting source. Please try again.');
                } else {
                    // Refresh the sources list
                    fetchSources();
                }
            } catch (error) {
                console.error('Error deleting source:', error);
                alert('Error deleting source. Please try again.');
            }
        }
    };

    return (
        <Container sx={{ mt: 4 }}>
            <Typography variant="h4" gutterBottom>
                Sources
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button variant="contained" onClick={() => handleOpen()}>
                    Create New Source
                </Button>
            </Box>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell align="right">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sources.map((source) => (
                            <TableRow key={source.id}>
                                <TableCell>{source.id}</TableCell>
                                <TableCell>{source.name}</TableCell>
                                <TableCell>
                                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'flex-end' }}>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={() => handleOpen(source)}
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            color="error"
                                            onClick={() => handleDelete(source.id)}
                                        >
                                            Delete
                                        </Button>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{editingId ? 'Edit Source' : 'Create New Source'}</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Source Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        fullWidth
                        margin="dense"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}

export default SourcePage;